<template>
  <div class="floors" :style="title === '去国外读大学' ? 'margin-bottom:17px' : ''" v-show="data.length">
    <!--TITLE S-->
    <div class="floors-title">
      <h2>{{ title }}</h2>
      <div class="title-items" v-if="title!=='去国外读大学'">
        <ul>
          <li
            v-for="(item, index) in data"
            :key="index"
            :class="currentItem===item.title?'active':''"
            @click="currentItem=item.title"
            v-show="data[item.title]!=''"
          >{{ item.title }}</li>
        </ul>
      </div>
    </div>
    <!--TITLE E-->
    <div class="floors-content" v-if="title === '去国外读大学'">
      <!--CONTENT S-->
      <div class="content">
        <a
          v-for="item in data"
          :href="`http://souke.xdf.cn/Course/${$store.state.soukecityId}-${item.Code}.html`"
          :key="item.Code"
        >
          <span class="coursename abroad" :title="item.Name">{{ item.Name }}</span>
          <span class="intro" :title="item.CourseIntro">{{ item.CourseIntro }}</span>
          <span class="studentlevel">{{ item.StudentLevel }}</span>
          <span class=" abroad"><button>立即咨询</button></span>
        </a>
      </div>
      <!--CONTENT E-->
    </div>
    <div class="floors-content" v-else>
      <!--CONTENT S-->
      <div class="content">
        <div v-for="(info, index) in data" :key="index" v-show="currentItem===info.title">
          <a
            v-for="item in info.content"
            :href="`http://souke.xdf.cn/Class/${$store.state.soukecityId}-${item.Id}.html`"
            :key="item.Id"
          >
            <span class="coursename" :title="item.Name">{{ item.Name }}</span>
            <span class="place" :title="item.LearnPlace"><i></i>{{ item.LearnPlace }}</span>
            <span class="time"><i></i>{{ item.StartDate.split('T')[0] }} 至 {{ item.EndDate.split('T')[0] }}</span>
            <span class="price">￥{{ item.Price }}</span>
            <span class="btn"><button>立即报名</button></span>
          </a>
        </div>
      </div>
      <!--CONTENT E-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloorSmall',
  props: ['title', 'itemsList', 'data'],
  data () {
    return {
      currentItem: String
    }
  },
  computed: {
    list () {
      return this.data
    }
  },
  watch: {
    list (newVal) {
      this.currentItem = this.data[0] ? this.data[0].title : ''
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.articleContentTitle
  flex: 2
  font-size: 15px
  color: #4a4a4a
  line-height: 35px
  em
    width: 4px
    height: 16px
    top: 3px
    position: relative
    display: inline-block
    margin-right: 10px
    background-color: #38bca4
  i
    position: $abs
.floors
  height: 350px
  padding-right: 10px
  display: flex
  flex-direction: column
  .floors-title
    height: 38px
    line-height: 38px
    padding-left: 12px
    border-bottom: 2px solid #98dfd2
    display: flex
    h2
      font-size: 18px
      flex: 1
    .title-items
      flex: 4
      ul
        li
          float: $fl
          color: #606060
          font-size: 14px
          padding: 0 20px
          cursor: pointer
        .active
          background: #fff
          color: #39BAA6
          height: 40px
          position: relative
          top: -2px
          border-left: 1px solid #a5e1d6
          border-right: 1px solid #a5e1d6
          border-top: 2px solid $themeColor
  .floors-content
    flex: 1
    display: flex
    .content
      flex: 10
      a
        display: flex
        cursor: pointer
        height: 60px
        line-height: 60px
        border: 1px solid transparent
        border-bottom-color: #eee
        color: #8e8e8e
        overflow: hidden
        &:hover
          background: #f4fcfc
          border-color: #cbe9e9
          overflow: hidden
          button
            background: #38bca4
            color: #fff
        span
          flex: 3
          text-align: center
          button
            flex: 1
            border: 1px solid #d0eae8
            border-radius: 2px
            background: #f4fcfc
            color: #38bca4
            padding: 4px 18px
            font-size: 16px
            margin-top: 12px
        .coursename
          font-size: 13px
          color: #333
          text-align: left
          padding: 0 10px
          width: 190.22px
          display: block
        .abroad
          flex: 2
          width: 190.22px
          display: block
        .place
          padding: 0 16px
          position: relative
          text-align: left
          width: 226.9px
          display: block
          i
            width: 14px
            height: 14px
            left: 0
            top: 50%
            margin-top: -7px
            display: block
            position: absolute
            background: url(http://images.xdf.cn/school/middleschool/static/images/sprite.png) no-repeat -178px -63px
        .time
          flex: 2
          padding: 0 16px
          position: relative
          text-align: left
          width: 151.26px
          display: block
          i
            width: 12px
            height: 14px
            left: 1px
            top: 50%
            margin-top: -7px
            display: block
            position: absolute
            background: url(http://images.xdf.cn/school/middleschool/static/images/sprite.png) no-repeat -216px -63px
        .intro
          flex: 2
          padding: 0 10px
          width: 190.22px
          display: block
        .studentlevel
          padding: 0 10px
          width: 285.33px
          display: block
        .price
          flex: 1
          color: #ff7011
          font-size: 18px
          width: 75.6px
          display: block
        .btn
          flex: 2
          width: 151.27px
          display: block
    .article
      flex: 3
      display: flex
      padding: 11px 0
      flex-direction: column
      .AD-articleContent
        flex: 2
        display: flex
        padding-left: 14px
        flex-direction: column
        ul
          flex: 10
          display: flex
          flex-direction: column
          li
            flex: 1
            width: 226px
            height: 29px
            line-height: 29px
            a
              width: 90%
              color: #666
              display: inline !important
              ellipsis()
              &:hover
                color: #38bca4
          .articleNumber
            width: 14px
            height: 14px
            border-radius: 2px
            display: inline-block
            text-align: center
            line-height: 14px
            color: #fff
            margin-right: 5px
            background-color: #cacaca
            font-size: 12px
            float: left
            position: relative
            top: 6px
          .hotNews
            background-color: #ff7011
      .articleAd
        flex: 1
</style>



// WEBPACK FOOTER //
// src/pages/middleschool/components/Floorsmall.vue